import React, { useState, useEffect } from 'react';
import DisneyPlusEnquiry from './DisneyPlusEnquiry';
import DisneyPlusActivated from './DisneyPlusActivated';
import DisneyPlusNotActivated from './DisneyPlusNotActivated';
import DisneyPlusError from './DisneyPlusError';
import { subInfo } from '../../Services/subInfo';
import { translations } from '../Text/translations';
import '../../css/disneyplus.scss';
import { setTrackingCookie } from '../../Utils/TrackingUtil';
import disneyLogo from '../../assets/disneyplus/disney-logo.png';
import disneyActivationEn from '../../assets/disneyplus/DisneyPlus_Activation_visual_en.png';
import disneyActivationTc from '../../assets/disneyplus/DisneyPlus_Activation_visual_tc.png';

const DisneyPlus = ({
  currentLang = 'en',
  nowSessionId,
  loginUrl,
  fsaType,
  fsa,
  cust_type,
  mobilenowid,
  emailnowid,
  nickname,
  novaXIndicator
}) => {
  const [subscribedInd, setSubscribedInd] = useState('');
  const [activationStatus, setActivationStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const [learnMoreUrl, setLearnMoreUrl] = useState('');

  useEffect(() => {
    if (nowSessionId) {
      if (!fsa) {
        setSubscribedInd('N');
        setLoading(false);
      } else {
        Promise.all([
          subInfo('D+')
        ]).then(([subInfoResponse]) => {
          if (subInfoResponse.subscribedInd)
            setSubscribedInd(subInfoResponse.subscribedInd);
          if (subInfoResponse.activationStatus)
            setActivationStatus(subInfoResponse.activationStatus);
          setLoading(false);
        }).catch((error) => {
          setLoading(false);
        });
      }

      if(!fsa) {
        // Guest
        setLearnMoreUrl('/get-started/?libid=L00455');
      } else {
        setLearnMoreUrl(`https://ssp.nowtv.now.com/choose-plan?libid=L00455&lang=${currentLang === 'en' ? 'en' : 'zh'}`);
      }
    } else {
      setLoading(false);
    }
  }, [fsaType, fsa, nowSessionId, cust_type, novaXIndicator]);

  useEffect(() => {
    setTrackingCookie();
  }, []);

  const handleLogonButtonClick = () => {
    window.location.href = loginUrl;
  };

  return (
    <div className="page-wrapper">
      <div className="container">
        <div className="disneyplus-wrapper">
          <img src={disneyLogo} alt="" className="logo" />

          {!nowSessionId && (
            <>
              <div className="message">
                <h2>{translations[currentLang].activiateDisneyplusAccount}</h2>
                <h3>{translations[currentLang].disneyplusSubject}</h3>
              </div>
              <div className="cta-buttons">
                <button className="btn primary" onClick={handleLogonButtonClick}>
                  {translations[currentLang].activiateDisneyplusAccount}
                </button>
              </div>
              <div className="preview-img">
                <img src={currentLang === 'en' ? disneyActivationEn : disneyActivationTc} alt="" />
              </div>
            </>
          )}
          {nowSessionId && loading && (
            <>
              <div className="name">
                <h2 className="name">{translations[currentLang].disneyplusSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].disneyplusSubjectGreeting2}</h2>
              </div>
              <div className="loading-wrapper show inline">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </>
          )}
          {nowSessionId && subscribedInd === 'N' && (
            <DisneyPlusEnquiry
              currentLang={currentLang}
              nickname={nickname}
              mobilenowid={mobilenowid}
              emailnowid={emailnowid}
              fsa={fsa}
              learnMoreUrl={learnMoreUrl}
            />
          )}
          {(subscribedInd === 'Y' && activationStatus === 'Activated') && (
            <DisneyPlusActivated
              currentLang={currentLang}
              nickname={nickname}
              mobilenowid={mobilenowid}
              emailnowid={emailnowid}
            />
          )}
          {(subscribedInd === 'Y' && activationStatus === 'Enrolled') && (
            <DisneyPlusNotActivated
              currentLang={currentLang}
              nickname={nickname}
              mobilenowid={mobilenowid}
              emailnowid={emailnowid}
              fsa={fsa}
              fsaType={fsaType}
            />
          )}
          {(subscribedInd === 'Y' && activationStatus !== 'Activated' && activationStatus !== 'Enrolled') && (
            <>
              <div className="name">
                <h2 className="name">{translations[currentLang].disneyplusSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].disneyplusSubjectGreeting2}</h2>
              </div>
              <div className="preview-img">
                <img src={currentLang === 'en' ? disneyActivationEn : disneyActivationTc} alt="" />
              </div>
            </>
          )}
          {((nowSessionId && !loading && (subscribedInd !== 'N' && subscribedInd !== 'Y'))) && (
            <DisneyPlusError
              currentLang={currentLang}
              nickname={nickname}
              mobilenowid={mobilenowid}
              emailnowid={emailnowid}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DisneyPlus;